import { extend } from 'vee-validate';
import { required, min_value, max_value, required_if } from 'vee-validate/dist/rules';

extend('required', required);
extend('required_if', required_if);
extend('min_value', min_value);
extend('max_value', max_value);
extend('url', (value) => {
    const stringValue = value.toString();
    if (['localhost', '127.0.0.1', 'customily'].includes(stringValue.toLowerCase())) return true;
    const regex = /^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})(\/.*)?$/i;
    return regex.test(stringValue) || 'Enter a valid URL';
});
